import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import "./PublicOrder.scss";

import { CHAT_ID, URI_API } from "../../../data";

const PublicOrder = () => {
  const { token } = useParams();
  const [order, setOrder] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [isPaymentSubmitting, setIsPaymentSubmitting] = useState(false);

  useEffect(() => {
    const fetchOrder = async () => {
      try {
        const response = await axios.get(`/api/order/link/${token}`);
        setOrder(response.data);
        setLoading(false);
      } catch (err) {
        setError("Заказ не найден или ссылка устарела");
        setLoading(false);
      }
    };

    fetchOrder();
  }, [token]);

  const handlePayment = async () => {
    if (isPaymentSubmitting || !order) return;

    console.log("Order object:", order);
    setIsPaymentSubmitting(true);

    try {
      // Создаем заказ на доплату с теми же данными что и оригинальный заказ
      const sendData = {
        group: order.group || "Квартира",
        room_count: order.room_count || 1,
        type: order.type || "Генеральная",
        bathroom_count: order.bathroom_count || 1,
        additional_services: order.additional_services || [],
        address: order.address,
        intercom: order.intercom,
        comment: order.comment,
        payment_type: "Безналичный расчет",
        price: order.price,
        totalPrice: order.price,
        user_name: order.user_name,
        phoneNumber: order.phoneNumber,
        user_name: order.user_name,
        phone_number: order.phone_number,
        additional_services: order.additional_services || [],
        date: order.date,
        repayOrderId: order._id || order.id || order.orderNumber, // указываем что это доплата
      };

      // Добавляем дополнительные поля если есть
      if (order.squareMeters) sendData.squareMeters = order.squareMeters;
      if (order.whatPurpose) sendData.whatPurpose = order.whatPurpose;
      if (order.numberOfFloors) sendData.numberOfFloors = order.numberOfFloors;
      if (order.elevator !== undefined) sendData.elevator = order.elevator;

      const response = await axios.post("/api/order/nouser", sendData);

      // Если получили URL для оплаты - перенаправляем на платежную систему
      if (response.data && response.data.url) {
        window.location.assign(response.data.url);
        return;
      }

      // Отправляем уведомление в Telegram
      try {
        await axios.post(URI_API, {
          chat_id: CHAT_ID,
          text: `Оплачен заказ №${String(order.orderNumber).padStart(
            3,
            "0"
          )} на сумму ${order.price?.toLocaleString()} руб`,
        });
      } catch (telegramError) {
        console.error("Ошибка отправки в Telegram:", telegramError);
      }

      // Обновляем статус заказа
      setOrder(prev => ({ ...prev, isPaid: true }));
      alert("Заказ успешно оплачен!");
    } catch (error) {
      console.error("Ошибка оплаты:", error);
      alert("Ошибка при оплате заказа. Попробуйте снова.");
    } finally {
      setIsPaymentSubmitting(false);
    }
  };

  if (loading) {
    return (
      <div className="public-order">
        <div className="public-order__loading">Загрузка заказа...</div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="public-order">
        <div className="public-order__error">{error}</div>
      </div>
    );
  }

  if (!order) {
    return (
      <div className="public-order">
        <div className="public-order__error">Заказ не найден</div>
      </div>
    );
  }

  // Форматируем дату
  const dateObj = new Date(order.date);
  const dateStr = dateObj.toLocaleDateString("ru-RU");
  const timeStr = dateObj.toLocaleTimeString("ru-RU", {
    hour: "2-digit",
    minute: "2-digit",
  });

  // Безопасное разделение адреса
  let region = "—",
    city = "—",
    street = "—";
  if (order.address) {
    // Убираем ведущую запятую и пробелы
    const address = order.address.replace(/^,\s*/, "");
    const addressParts = address.split(",").map(part => part.trim());
    region = addressParts[0] || "—";
    city = addressParts[1] || "—";
    street = addressParts.slice(2).join(", ") || "—";
  }

  return (
    <div className="public-order">
      <h2 className="public-order__title">Информация о заказе</h2>
      <div className="public-order__content">
        <h3 className="public-order__number">
          Заказ №{String(order.orderNumber).padStart(3, "0")} от <br />
          {order.user_name} ( Номер телефона: {order.phone_number})
        </h3>

        <div className="public-order__details">
          <p className="public-order__type">{order.type} уборка</p>
          <p>{order.room_count} – комнатная</p>
          <p>{order.bathroom_count} – Сан/Узел</p>

          {order.additional_services?.length > 0 && (
            <>
              <p className="public-order__section-title">
                Дополнительные услуги:
              </p>
              {order.additional_services.map((service, index) => (
                <p key={index} className="public-order__service">
                  {service.name} – ({service.count || 1})
                </p>
              ))}
            </>
          )}

          <p className="public-order__section-title">Дата и время:</p>
          <p>
            {dateStr} в {timeStr}
          </p>

          <p className="public-order__section-title">
            Адрес: {region},{""}
            {city}
          </p>

          <p>Квартира – {street}</p>
          <p>Наличие домофона – {order.intercom || "—"}</p>

          {order.comment && (
            <>
              <p className="public-order__section-title">Комментарий:</p>
              <p>{order.comment}</p>
            </>
          )}

          <p className="public-order__section-title">Стоимость:</p>
          <p className="public-order__price">
            {order.price?.toLocaleString()} руб
          </p>

          {/* <p className="public-order__section-title">Способ оплаты:</p>
          <p>{order.payment_type}</p> */}

          {/* <p className="public-order__section-title">Статус заказа:</p>
          <p className="public-order__status">
            {order.isPaid ? "Оплачен" : "Ожидает оплаты"}
          </p> */}

          {/* <p className="public-order__section-title">Технический статус:</p>
          <p>{order.status}</p> */}

          <p className="public-order__section-title">Уборщики:</p>
          {order.cleaners && order.cleaners.length > 0 ? (
            <ul>
              {order.cleaners.map((cleaner, idx) => (
                <li key={idx}>
                  {cleaner.name || "Без имени"} -{" "}
                  {cleaner.phone || "Без номера"}
                </li>
              ))}
            </ul>
          ) : (
            <p>Нет назначенных уборщиков</p>
          )}

          {!order.isPaid && (
            <div className="public-order__payment-section">
              <div className="public-order__payment-total">
                <p>
                  К оплате: <strong>{order.price?.toLocaleString()} руб</strong>
                </p>
              </div>

              <button
                className={`public-order__payment-button ${
                  isPaymentSubmitting ? "disabled" : ""
                }`}
                onClick={handlePayment}
                disabled={isPaymentSubmitting}>
                {isPaymentSubmitting
                  ? "Обработка платежа..."
                  : "Оплатить картой"}
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default PublicOrder;
